<template>
  <div
    v-if="!manualHiddenProfile"
    class="narrator-profile"
    @click="onClick"
  >
    <div class="narrator-profile-discern">
      <div class="narrator-profile-discern-inner">
        <div class="narrator-profile-portrait">
          <!-- whether to use customBranding -->
          <div
            v-if="customBranding"
            class="narrator-profile-portrait-user"
          >
            <img
              v-if="portrait"
              :src="portrait"
            >
            <i
              v-else
              class="isif isif-man"
            />
          </div>
          <img
            v-else
            class="narrator-profile-portrait-istaging"
            :src="iStagingPortrait"
          >
          <div class="narrator-profile-more">
            <i class="isif isif-dots-3-h" />
          </div>
        </div>
      </div>
    </div>
    <ModalProfile ref="ModalProfile" />
  </div>
</template>

<script>
// import _ from 'lodash'
import iStagingPortrait from '../../../../assets/images/istaging.svg'
import ModalProfile from '../../modals/ModalProfile'
import queryString from '../../../../api/query-string'

export default {
  name: 'NarratorProfile',
  components: {
    ModalProfile
  },
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: Object,
      required: true
    }
  },
  computed: {
    portrait () {
      // if (_.has(this.dataset.portrait, 'cutUrl')) {
      //   return this.dataset.portrait.cutUrl
      // }
      return this.dataset.profileUrl || null
    },
    iStagingPortrait () {
      return iStagingPortrait
    },
    customBranding () {
      const { customSetting } = this.dataset
      return customSetting.customBranding
    },
    name () {
      let name = 'iStaging'
      if (this.customBranding) {
        name = this.dataset.name
      }
      return name || this.$t('None')
    },
    companyDisplayName () {
      const company = this.dataset.companyDisplayName
      return this.customBranding ? company : null
    },
    manualHiddenProfile () {
      return queryString.hideContactInfo
    }
  },
  methods: {
    onClick () {
      if (!this.customBranding) {
        window.open('https://www.istaging.com', '_blank')
        return
      }
      this.$refs.ModalProfile.show()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.narrator-profile {
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;

  .narrator-profile-discern {
    width: 40px;
    flex-shrink: 0;

    @media (min-width: $response) {
      width: 48px;
    }

    .narrator-profile-portrait {
      position: relative;
      padding-top: 100%;
    }

    .narrator-profile-portrait-user,
    .narrator-profile-portrait-istaging {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      overflow: hidden;
    }

    .narrator-profile-portrait-user {
      i, img {
        width: 100%;
        height: 100%;
      }

      i {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $white;
        color: $dusty-gray;
        font-size: 3rem;
      }
    }

    .narrator-profile-portrait-istaging {
      width: 100%;
      height: 100%;
    }

    .narrator-profile-more {
      width: 40%;
      padding-top: 40%;
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;

      i {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 50%;
        background-color: $black;
        border: 2px solid $white;
        color: $white;
      }
    }

    & + .narrator-profile-info {
      margin-left: 0.75em;
    }
  }

  .narrator-profile-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    overflow: hidden;

    @media (min-width: $response) {
      width: 13.15em;
    }

    p {
      flex-basis: 100%;
      line-height: 1.4;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      &.narrator-profile-name {
        font-size: 1.375rem;
      }

      &.narrator-profile-company {
        font-size: 1.125rem;
      }
    }
  }
}
</style>
